module.exports = __webpack_public_path__ + "img/eyyb-t5.f68e7a12.jpg";